module.exports = __webpack_public_path__ + "img/icon_patent_pt.ccf3a0fa.png";